const { getPrefixProperty } = require('./prefix-property');

/**
 * transform
 */
module.exports = (() => {

  /**
   * @private
   * @param _vals {object}
   */
  const getTransforms_ = (_vals) => {
    return _.reduce(_vals, (_memo, _val, _key) => {
      const name_ = _key.match(/^(translate|scale|rotate|skew)([XYZ]?)$/);

      if(name_[0] !== 'scale') {
        if( !(typeof _memo[name_[1]] !== 'undefined' && _memo[name_[1]] !== null) ) {
          _memo[name_[1]] = {};
        }
        _memo[name_[1]][name_[2].toLowerCase()] = _val;
      }
      else {
        _memo[name_[0]] = _val;
      }

      return _memo;
    }, {});
  };

  /**
   * @private
   */
  const getHasTransform3d_ = () => {
    const style_ = document.createElement('div').style;
    const props_ = ['-webkit-transform', 'MozTransform'];

    for (let i_ = 0, p_; p_ = props_[i_]; i_++) if (p_ in style_) {
      style_[p_] = '';
      style_[p_] = 'rotateY(90deg)';
      return style_[p_] !== '';
    }
  };

  /**
   * @private
   * @param _val {string}
   * @param _unit {string}
   */
  const getVal_ = (_val, _unit) => {
    if(typeof _val !== 'undefined' && _val !== null) {
      return _val + _unit;
    } else {
      return 0;
    }
  };

  /**
   * @private
   * @param _transforms {object}
   */
  const getTransformVal_ = (_transforms) => {
    const hasTransform3d_ = getHasTransform3d_();

    return _.reduce(_transforms, (_memo, _val, _key) => {

      const val_  = {};
      const unit_ = {};
      _.forEach(_val, (__val, __key) => {
        const v_ = __val.toString().match(/(^-?[0-9]+\.?[0-9]*)(px|%|deg)?$/);
        val_[__key]  = v_[1];
        unit_[__key] = v_[2];
      });

      if(_key !== 'skew') {
        if(Object.prototype.toString.call(_val) === '[object Object]') {  // isnt 'scale'
          const unit__ = _.reduce(unit_, (__memo, __val, __key) => {
            switch(_key) {
              case 'translate':
                __memo[__key] = unit_[__key] ? unit_[__key] : 'px';
                break;
              case 'scale':
                __memo[__key] = '';
                break;
              case 'rotate':
                __memo[__key] = unit_[__key] ? unit_[__key] : 'deg';
                break;
            }
            return __memo;
          }, {});

          const vals_ = {
            x: getVal_(val_.x, unit__.x),
            y: getVal_(val_.y, unit__.y),
            z: getVal_(val_.z, unit__.z),
          };
          if(hasTransform3d_) {
            _memo += `${ _key }3d(${ vals_.x },${ vals_.y },${ vals_.z })`;
          } else {
            _memo += `${ _key }(${ vals_.x },${ vals_.y })`;
          }
        }
        else {  // is 'scale'
          _memo += `${ _key }(${ _val })`;
        }

      }
      else {
        const unit__ = _.reduce(unit_, (__memo, __val, __key) => {
          __memo[__key] = unit_[__key] ? unit_[__key] : 'deg';
          return __memo;
        }, {});
        const vals_ = {
          x: getVal_(val_.x, unit__.x),
          y: getVal_(val_.y, unit__.y),
        };
        _memo += `${ _key }(${ vals_.x },${ vals_.y })`;
      }

      return _memo;
    }, '');
  };

  return {
    /**
     * @param _$el {HTMLElement}
     * @param _vals {object}
     *
     * @example
     *   transform($el, {
     *     translateX: '100px',
     *     translateY: '50%',
     *     translateX: 50,
     *     scale: 2,
     *     scaleX: 3,
     *     rotateY: 45,
     *     skewX: '30deg',
     *   });
     */
    transform: (_$el, _vals) => {
      _$el.style[getPrefixProperty('transform')] = getTransformVal_(getTransforms_(_vals));
    },
  }

})();



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/module/transform.js
 **/